export default "__VITE_ASSET__d73e23ce__"